//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
// Copyright :derechos_de_autor: 2021 Service-Conseil IRGT Inc. All rights reserved.
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------
// Dependencies
import React, { useState } from "react";
import { Button, Input, Col, Form, Checkbox, Typography, Modal, Spin } from "antd";

import iconIRGT from "../../images/Logo-irgt.png";
import { useLocation, useNavigate } from "react-router-dom";
import "../../styles/styles.css"
import PdfPrivacy from "../../common/PdfPrivacy";
import { getSneakPeekWithEmail, setSneakPeekWithEmail, updateSneakPeekWithEmail } from "../../firebase/endpoints";





const { Text } = Typography;
const LoginForm: React.FC = () => {

  // Hooks React
  const navigate = useNavigate();
  const location = useLocation();

  // States
  const [email, setEmail] = useState<string>("")
  const [fullName, setFullName] = useState<string>("")
  const [company, setCompany] = useState<string>("")
  const [checkPrivacy, setCheckPrivacy] = useState<boolean>(false)
  const [openPdf, setOpenPdf] = useState<boolean>(false);
  const [loading, setLoading] = useState(false)
  // Handlers

  const handleOnStartLogin = async () => {
    // Esta función se ejecutará cuando se envíe el formulario
    setLoading(true);
    // Verificación de campos vacíos
    if (!email.trim() || !fullName.trim() || !company.trim()) {

      setLoading(false);
      return;
    }

    // Validación de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      alert("Please enter a valid email address!");
      setLoading(false);
      return;
    }

    // Verificación de aceptación de política de privacidad
    if (!checkPrivacy) {
      alert("You must accept the privacy policy!");
      setLoading(false);
      return;
    }

    // Intento de obtener un Sneak Peek existente con el email proporcionado
    const sneakPeekResponse = await getSneakPeekWithEmail(email.trim());
    if (sneakPeekResponse) {
      await updateSneakPeekWithEmail(sneakPeekResponse.idSneakPeek, sneakPeekResponse.visitCounter + 1);
    } else {
      // Si no existe, crear uno nuevo
      await setSneakPeekWithEmail(email.trim(), fullName.trim(), company.trim(), true);
    }

    // Navegación al perfil del candidato basado en el idioma actual de la página
    navigate(location.pathname === '/en' ? "/en/candidate" : "/fr/candidate");

    setLoading(false);
  };



  return (
    <Col className="containerLoginForm" style={{ zIndex: 2 }}>
      <div style={{ height: "30%", display: "flex", justifyContent: "center", alignContent: "center", alignItems: "center", marginTop: "3%" }}>
        <img src={iconIRGT} style={{ height: "100%", width: "100%", objectFit: "contain" }} alt={iconIRGT} />
      </div>

      <Modal
        width={"70vw"}
        centered
        open={openPdf}

        closable={false}
        footer={[
          <button style={{
            backgroundColor: "#1890ff",
            borderColor: "#ffffff",
            color: "white",
            fontSize: 16,
            borderRadius: 5,
            paddingRight: 20,
            paddingTop: 3,
            paddingBottom: 3,
            paddingLeft: 20,

          }}
            key="ok" onClick={() => { setOpenPdf(false) }}
          >OK
          </button>,
        ]}
      >
        <div className="contenedor" style={{ width: "100%", height: "80vh", overflow: "scroll" }}>
          <img src={iconIRGT} alt="" style={{ height: "10vh" }} />
          <PdfPrivacy />
        </div>
      </Modal>
      {
        loading ? (
          <div style={{ height: '50%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <Spin size="large" />
          </div>
        ) : (

          <div style={{ width: "35vw", height: "45vh", padding: "1vh", overflow: "auto", display: "flex", alignItems: "center", flexDirection: "column" }}>
            <Form size="large" onFinish={handleOnStartLogin}>
              <div style={{ width: "100%", height: "100%" }}>
                <Form.Item
                  name="email"
                  rules={[
                    {
                      type: "email",
                      message: location.pathname === '/en' ? 'Check your email' : "Vérifiez votre e-mail",
                    },
                    {
                      required: true,
                      message: location.pathname === '/en' ? 'Check your email' : "Vérifiez votre e-mail",
                    },
                  ]}
                >
                  <Input
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    style={{ marginTop: "0.5vh", width: "25vw", height: "5vh", fontSize: "3vh" }}
                    placeholder={location.pathname === '/en' ? 'Email' : "Courriel"} />
                </Form.Item>

                <Form.Item
                  name="Full Name"
                  rules={[{
                    required: true,
                    message: location.pathname === '/en' ? 'Blank full name' : "Nom complet vide"
                  },]}
                  style={{ fontSize: "20vh" }}
                >
                  <Input
                    onChange={(e) => setFullName(e.target.value)}
                    style={{ marginTop: "0.5vh", width: "25vw", height: "5vh", fontSize: "3vh" }}
                    placeholder={location.pathname === '/en' ? 'Full Name' : "Nom complet"}
                  />
                </Form.Item>

                <Form.Item
                  name="Company"
                  rules={[
                    {
                      required: true,
                      message: location.pathname === '/en' ? 'Empty company name' : "Nom de l'entreprise vide"
                    },
                  ]}
                >
                  <Input
                    onChange={(e) => setCompany(e.target.value)}
                    style={{
                      marginTop: "0.5vh",
                      width: "25vw",
                      height: "5vh",
                      fontSize: "3vh"
                    }}
                    placeholder={location.pathname === '/en' ? 'Company Name' : "Nom de l'entreprise"}
                  />
                </Form.Item>
                <Form.Item
                  name="Check"
                  rules={[
                    {
                      required: true,
                      message: location.pathname === '/en' ? 'Terms of use not accepted' : "Conditions d'utilisation non acceptées"
                    },
                  ]}
                >
                  <div style={{ marginTop: "0.5vh", width: "25vw", height: "5vh" }}>
                    <Checkbox checked={checkPrivacy} onChange={(e) => setCheckPrivacy(e.target.checked)}></Checkbox>
                    <Text onClick={() => setOpenPdf(true)} style={{ marginLeft: "1vw", fontSize: "2vh", textDecoration: "underline", color: "#0000ff", cursor: "pointer" }}>{location.pathname === '/en' ? 'I agree to receive communications from Career Swipe' : "J'accepte de recevoir des communications des Service Career Swipe"}</Text>
                  </div>
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    color="#404193"
                    style={{
                      width: "100%",
                      backgroundColor: "#404193",
                      fontSize: 22,
                      height: "8vh",
                      borderBottomLeftRadius: 20,
                      borderBottomRightRadius: 20,
                      borderTopLeftRadius: 0,
                      borderTopRightRadius: 0,

                    }}
                  >
                    {location.pathname === '/en' ? 'View Profiles' : 'Consulter les profils'}
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </div>
        )
      }
    </Col>
  );
};

// Exports
export default LoginForm;
